export const isDraggableDevice = (): boolean => {
  /**
   * Так как четко нельзя определить touch или нет,
   * то проверяем на свойство.
   */
  if (process.env.browser) {
    return 'ontouchstart' in window
  }

  return false
}
